import { api } from './api';

// Thin wrapper for Phase 1 unified-contact endpoints.
// All requests are tenant-scoped server-side; frontend never sends tenant_id.

export const uc = {
  list: (params = {}) => api.get('/v2/contacts', { params }).then(r => r.data),
  search: (q, limit = 20) => api.get('/v2/contacts/search', { params: { q, limit } }).then(r => r.data),
  get: (id) => api.get(`/v2/contacts/${id}`).then(r => r.data),
  byIds: (ids) => ids.length
    ? api.get('/v2/contacts', { params: { ids: ids.join(','), limit: 500 } }).then(r => r.data.items || [])
    : Promise.resolve([]),
  create: (payload) => api.post('/v2/contacts', payload).then(r => r.data),
  update: (id, patch) => api.patch(`/v2/contacts/${id}`, patch).then(r => r.data),
  remove: (id) => api.delete(`/v2/contacts/${id}`).then(r => r.data),
  // Ticket 208: the email recipient picker. Pages only contacts with an email, marks the ones a
  // send would skip; `emailAudienceAll` is "select all matching"; `emailStatus` marks addresses.
  emailAudience: (params = {}) => api.get('/v2/contacts/email-audience', { params }).then(r => r.data),
  emailAudienceAll: (params = {}) =>
    api.get('/v2/contacts/email-audience/all', { params }).then(r => r.data),
  emailStatus: (emails) =>
    api.post('/v2/contacts/email-status', { emails }).then(r => r.data.blocked || {}),
  duplicates: (id) => api.get(`/v2/contacts/${id}/duplicates`).then(r => r.data),
  // Ticket 232: co-borrowers from this contact's loan files (Relationships tab).
  relationships: (id) => api.get(`/v2/contacts/${id}/relationships`).then(r => r.data),
  merge: (survivor_id, duplicate_id, prefer = 'survivor') =>
    api.post('/v2/contacts/merge', { survivor_id, duplicate_id, prefer }).then(r => r.data),
  recordConsent: (id, payload) =>
    api.post(`/v2/contacts/${id}/consent`, payload).then(r => r.data),
  // `arg` is a limit (old callers) or a params object: { limit, before, kinds }.
  timeline: (id, arg = 100) =>
    api.get(`/v2/contacts/${id}/timeline`, { params: typeof arg === 'number' ? { limit: arg } : arg })
      .then(r => r.data),
  // Ticket 188 D13: params { limit, before }.
  audit: (id, params = {}) =>
    api.get(`/v2/contacts/${id}/audit`, { params }).then(r => r.data),
};

// GHL merge queue (ticket 122 S6) — review pairs sync.py queued instead of
// auto-merging.
export const mergeQueue = {
  summary: () => api.get('/v2/merge-queue/summary').then(r => r.data),
  list: (params = {}) => api.get('/v2/merge-queue', { params }).then(r => r.data),
  merge: (itemId, survivor_id) => api.post(`/v2/merge-queue/${itemId}/merge`, { survivor_id }).then(r => r.data),
  dismiss: (itemId) => api.post(`/v2/merge-queue/${itemId}/dismiss`).then(r => r.data),
  archive: (itemId) => api.post(`/v2/merge-queue/${itemId}/archive`).then(r => r.data),
};

export const CONTACT_TYPES = [
  { k: 'lead', l: 'Lead' },
  { k: 'borrower', l: 'Borrower' },
  { k: 'co_borrower', l: 'Co-Borrower' },
  { k: 'buyer', l: 'Buyer' },
  { k: 'seller', l: 'Seller' },
  { k: 'past_client', l: 'Past Client' },
  { k: 'sphere', l: 'Sphere' },
  { k: 'realtor', l: 'Realtor' },
  { k: 'referral_partner', l: 'Referral Partner' },
  { k: 'builder', l: 'Builder' },
  { k: 'title', l: 'Title' },
  { k: 'attorney', l: 'Attorney' },
  { k: 'cpa', l: 'CPA' },
  { k: 'lender', l: 'Lender' },
  { k: 'investor', l: 'Investor' },
  { k: 'renter', l: 'Renter' },
  { k: 'other', l: 'Other' },
];

export const LEAD_STATUSES = [
  { k: 'new', l: 'New' },
  { k: 'attempted', l: 'Attempted' },
  { k: 'contacted', l: 'Contacted' },
  { k: 'qualified', l: 'Qualified' },
  { k: 'nurture', l: 'Nurture' },
  { k: 'active', l: 'Active' },
  { k: 'converted', l: 'Converted' },
  { k: 'unresponsive', l: 'Unresponsive' },
  { k: 'disqualified', l: 'Disqualified' },
  { k: 'closed', l: 'Closed' },
];
